import styled from 'styled-components';
import React, { useEffect, useState } from 'react';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

export default function ClientCheck() {
  //variable
  const [userList, setUserList] = useState([]);
  const [result, setResult] = useState({
    userId: '',
    lat: '',
    lon: '',
    sendType: 'qr',
  });
  const [isSubmit, setIsSubmit] = useState(false)

  //Effect
  useEffect(() => {
    getUserList();
    getCurrentLocation();
  }, []);

  //Function
  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
          const { latitude, longitude } = position.coords;

          result.lat = latitude;
          result.lon = longitude;
        }, (error) => {
          console.log(error);
        }
      );
    } else {
      console.log(new Error('Geolocation is not supported by this browser.'));
    }
  };

  const getUserList = () => {
    Server.sendGet('user/hq', {}, getUserListCallback).then();
  };

  const getUserListCallback = res => {
    setUserList(res['resultList']);
  };

  const sendResult = () => {
    if(!isSubmit) {
      setIsSubmit(true);
      if(result.lat === '' || result.lon === '') {
        Common.errorMsg('Click the location check button.');
        setIsSubmit(false);
        return false;
      }

      if (result.userId === '') {
        Common.errorMsg('Select user.');
        setIsSubmit(false);
        return false;
      }
      Server.sendPostInHq('user/hq', result, sendResultCallback).then();
    }
  };

  const sendResultCallback = res => {
    Common.errorMsg('ok');

    setIsSubmit(false);
  };

  return (
    <CheckWrap>
      <div className='content-inner'>
        <div className='title'>
          <div className='title-head'>
            <i/>
            <h4>Today History</h4>
          </div>
        </div>

        <div className='content'>
          <div className='table-content'>
            <table>
              <colgroup>
                <col width='33.33%'/>
                <col width='33.33%'/>
                <col width='33.33%'/>
              </colgroup>
              <tbody>
              <tr>
                <td colSpan={3}>
                  <select
                    value={result?.userId}
                    onChange={(e) => {
                      setResult(() => {
                        return {
                          ...result,
                          userId: e.target.value,
                        }
                      })
                    }}
                  >
                    <option value=''>---Select user---</option>
                    {userList?.map(item => (
                      <option value={item.userId}>{item.userName}</option>
                    ))}
                  </select>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className='select-btn'>
          <button
            onClick={() => sendResult()}
          >Check
          </button>
        </div>
      </div>
    </CheckWrap>
  )
}

const CheckWrap = styled.div`
  position: relative;
  flex: 1;
  background: #ffffff;

  .content-inner {
    position: relative;

    .content {
      height: auto !important;
    }
  }

  * {
    font-family: 'Apple SD Gothic Neo', sans-serif;
  }

  table {
    thead th {
      padding: 20px 0;
      font-weight: 400;
      font-size: 14px;
      color: #111111;
      background: #f8f8f8;
      text-align: center;
      border-bottom: 1px solid #eeeeee;
      vertical-align: middle;
    }

    tbody {
      tr {
        td {
          padding: 30px 0;
          font-weight: 400;
          font-size: 14px;
          color: #000000;
          text-align: center;
          vertical-align: middle;
          border-bottom: 1px solid #eeeeee;

          select {
            padding: 0 16px;
            height: 40px;
            line-height: 40px;
            width: calc(100% - 32px);
            border-radius: 10px;
            border-color: #d1d1d1;
            font-weight: 400;
            font-size: 14px;
            color: #111111;
            background: url('https://ust-kr.s3.ap-northeast-2.amazonaws.com/assets/layout/drop_arrow.svg') right 16px top 50% no-repeat;
            outline: none;
          }

          button {
            padding: 0 20px;
            height: 40px;
            line-height: 40px;
            border-radius: 10px;
            font-weight: 400;
            font-size: 14px;
            color: #111111;
            background: #f1f1f1;
          }

          span {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 9999px;
            width: 30px;
            height: 20px;
            line-height: 20px;
            font-size: 14px;
            color: #ffffff;


            &.Y {
              background: rgb(34, 197, 94);
            }

            &.N {
              background: rgb(239, 68, 68);
            }

            &.C {
              background: rgb(234, 179, 8);
            }
          }
        }
      }
    }
  }

  .select-btn {
    margin-top: 45px;

    button {
      width: 100%;
      height: 45px;
      line-height: 45px;
      text-align: center;
      font-weight: 600;
      font-size: 18px;
      color: #ffffff;
      background: #0072B9;
    }
  }

  @media only screen and (max-width: 1024px) {
    padding: 20px;
    height: 100vh;

    .content-inner {
      height: 100%;

      .content {
        max-height: calc(100vh - 270px);
        height: auto !important;
      }
    }

    .select-btn {
      position: absolute;
      bottom: 100px;
      width: 100%;
      margin: 0;

      button {
        width: 100%;
        height: 45px;
        line-height: 45px;
        text-align: center;
        font-weight: 600;
        font-size: 18px;
        color: #ffffff;
        background: #0072B9;
      }
    }
  }
`;